import React, { useState } from "react";
import Swal from "sweetalert2";
import './editPackage.css';

import EditProductDetails from "./editProductDetails";
import EditBilling from "./editBilling";
import EditKeyword from "./editKeyword";
import EditChargingConfig from "./editChargingConfig";
import EditFallback from "./editFallback";
import EditSms from "./editSms";
import EditPartnerNotification from "./editPartnerNotification";
import EditCustomerNotification from "./editCustomerNotification";
const EditPackage = ({ setEditCpModal, editData, getAllData }) => {
  const [activeTab, setActiveTab] = useState('productDetails');

  const [editCpForm, setEditCpForm] = useState({
    firstName: editData?.firstName || "",
    lastName: editData?.lastName || "",
  });

  const [editError, setEditError] = useState(false);

  const tabs = [
    { id: 'productDetails', label: 'Product Details' },
    { id: 'billing', label: 'Billing' },
    { id: 'keyword', label: 'Keyword' },
    { id: 'chargingConfiguration', label: 'Charging Configuration' },
    { id: 'fallback', label: 'Fallback' },
    { id: 'sms', label: 'SMS' },
    { id: 'partnerNotification', label: 'Partner Notification' },
    { id: 'customerNotification', label: 'Customer Notification' },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case 'productDetails':
        return <EditProductDetails editData={editData} onUpdate={getAllData} />;
      case 'billing':
        return <EditBilling editData={editData} onUpdate={getAllData} />;
      case 'keyword':
        return <EditKeyword editData={editData} onUpdate={getAllData} />;
      case 'chargingConfiguration':
        return <EditChargingConfig editData={editData} onUpdate={getAllData} />;
      case 'fallback':
        return <EditFallback editData={editData} onUpdate={getAllData} />;
      case 'sms':
        return <EditSms editData={editData} onUpdate={getAllData} />;
      case 'partnerNotification':
        return <EditPartnerNotification editData={editData} onUpdate={getAllData} />;
      case 'customerNotification':
        return <EditCustomerNotification editData={editData} onUpdate={getAllData} />;
      default:
        return null;
    }
  };

  return (
    <>
     {/* <div className="edit-package-container" id="edit_pckg"> */}
    {/* <div className="box-body"> */}
      <ul className="nav nav-tabs" id="packageTabs" role="tablist">
        {tabs.map((tab) => (
          <li className="nav-item " role="presentation" key={tab.id}>
            <a
              className={`nav-link ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
              role="tab"
              style={{ cursor: 'pointer' }}
            >
              {tab.label}
            </a>
          </li>
        ))}
      </ul>
      <div className="tab-content mt-3">
        {renderTabContent()}
      </div>
    {/* </div> */}
  {/* </div> */}
  </>
  );
};

export default EditPackage;
